import { useState } from "react"

import { Cross1Icon } from "@radix-ui/react-icons"

import styles from "./SummaryTextModal.module.scss"

import ModalDialog from "@/main/components/ui/ModalDialog/ModalDialog"
import {
	FragmentType,
	getFragmentData,
	graphql,
} from "@/souhl_admin/gql/__generated__"

const summaryTextModalFragment = graphql(/* GraphQL */ `
	fragment SummaryTextModalFragment on CompanySmsSendingRuleV2 {
		summaryText
	}
`)

type CommonProps = {
	triggerClassName?: string
	/** トリガーボタンの文言。デフォルトは「テキストを確認」 */
	triggerLabel?: string
	/** モーダルの見出し。デフォルトは「店舗送付用テキスト」 */
	title?: string
}

type Props = CommonProps &
	(
		| {
				/** ルール単位の summaryText を表示する */
				fragment: FragmentType<typeof summaryTextModalFragment>
				summaryText?: never
		  }
		| {
				/** 会社単位など、呼び出し側で組み立て済みのテキストを表示する */
				summaryText: string
				fragment?: never
		  }
	)

const SummaryTextModal = ({
	triggerClassName,
	triggerLabel = "テキストを確認",
	title = "店舗送付用テキスト",
	...source
}: Props) => {
	const rule =
		source.fragment !== undefined
			? getFragmentData(summaryTextModalFragment, source.fragment)
			: undefined
	const summaryText = (rule ? rule.summaryText : source.summaryText) || ""

	const [isModalOpen, setIsModalOpen] = useState(false)

	const handleCopyToClipboard = async () => {
		try {
			await navigator.clipboard.writeText(summaryText)
			alert("クリップボードにコピーしました")
			setIsModalOpen(false)
		} catch {
			alert("コピーに失敗しました")
		}
	}

	return (
		<>
			<button
				type="button"
				className={triggerClassName || styles.trigger_button}
				onClick={() => setIsModalOpen(true)}
			>
				{triggerLabel}
			</button>

			<ModalDialog
				isOpen={isModalOpen}
				onOpenChange={setIsModalOpen}
				contentClassName={styles.summary_modal}
			>
				<div className={styles.summary_modal_content}>
					<div className={styles.header}>
						<h2>{title}</h2>
						<button
							type="button"
							className={styles.close_button}
							onClick={() => setIsModalOpen(false)}
						>
							<Cross1Icon />
						</button>
					</div>
					<div className={styles.textarea_container}>
						<textarea
							className={styles.summary_textarea}
							value={summaryText}
							placeholder="テキストがありません（店舗が紐づいているルールがない場合は空になります）"
							readOnly
						/>
					</div>
					<div className={styles.modal_actions}>
						<button
							className={styles.copy_button}
							onClick={handleCopyToClipboard}
						>
							テキストをコピー
						</button>
					</div>
				</div>
			</ModalDialog>
		</>
	)
}

export default SummaryTextModal
